import AppDialog from "./appDialog/appDialog";
import AppointmentStatus from "./appointmentStatus/appointmentStatus";
import AppointmentCalender from "./AppointmentCalender";
import AppointmentCard3 from "./AppointmentCard/AppointmentCard3";
import AppointmentComponent from "./AppointmentCard/AppointmentComponent";
import CircularLoader from "./circularLoader/circularLoader";
import NewSelDropdown from './SelectDropdown/NewSelectDropdown';
import PhoneNumber from './PhoneNumber/PhoneNumber'

const Widgets = {
  AppDialog,
  AppointmentStatus,
  AppointmentCalender,
  AppointmentCard3,
  AppointmentComponent,
  CircularLoader,
  NewSelDropdown,
  PhoneNumber
};

export default Widgets;
